export default __webpack_public_path__ + "0b9c4cd50f9ad73850d218839e45e1f5.svg";